import React, { Fragment } from 'react';

import validator from 'validator';
import _ from 'lodash';
import PropTypes from 'prop-types';

import {
    Popup,
    EditableComponent,
    Loading,
    InputField,
} from 'arteia-js/components';

import { API } from 'arteia-js/services';

import getUTMParams from '../getUTMParams';
import TranslatedText from '../../translations/TranslatedText';
import SignUpInfo from './components/SignUpInfo';
import SignUpActions from './components/SignUpActions';
import t from '../../translations/getTranslation';
import withLanguage from '../../translations/withLanguage';
import withUserData from '../../EeckmanClientInfo/withUserData';


class SignUp extends EditableComponent {
    constructor(props) {
        super(props);

        const { userData } = props;

        this.state = {
            registerErrored: false,
            registering: false,
            registerSuccessful: false,
            errorMessage: '',
            email: (userData || {}).email || '',
            fullname: '',
            passwordA: '',
            passwordB: '',
        };
    }

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        const email = urlParams.get('email');
        if (email) {
            this.setState({ email });
        }
    }

    staticTexts = {
        weakPassword: t(this.props.lang, 'Password should be'),
        differentPasswords: t(this.props.lang, 'Passwords do not match'),
    };

    registerConfirm = () => {
        const { lang } = this.props;
        const { email, passwordA: password, fullname: fullName } = this.state;
        const {
            inputsFilled, strongPassword, passwordsSame, emailCorrect,
        } = this.isDataCorrect();
        const allowSave = inputsFilled && strongPassword && passwordsSame && emailCorrect;

        if (!allowSave) {
            return this.setState({
                registerErrored: true,
            });
        }

        this.setState({
            registering: true,
            registerErrored: false,
            registerSuccessful: false,
        });

        return API.post('/sign-up', {
            email,
            password,
            fullName,
            utmParams: getUTMParams(this.props.location),
        })
            .then((res) => {
                this.setState({
                    registering: false,
                    registerSuccessful: true,
                });

                const { secureUrl, token } = res;

                setTimeout(() => {
                    window.location.assign(`${secureUrl}/redirect?returnTo=client&token=${token}`);
                }, 1500);
            })
            .catch((err) => {
                const { status, response } = err;
                const { data = {} } = _.get(response, 'body', {});

                let message = t(lang, 'Something went wrong');

                if (status === 400 && data.fieldErrors && data.fieldErrors['user.email']) {
                    const code = _.get(data.fieldErrors['user.email'], '0.code');
                    if (code === '[duplicate]user.email') {
                        message = t(lang, 'A user with this email exists');
                    }
                }

                this.setState({
                    registering: false,
                    registerErrored: true,
                    errorMessage: message,
                });
            });
    };

    handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            this.registerConfirm();
        }
    };

    isDataCorrect = () => {
        const { email, passwordA, passwordB } = this.state;

        const inputsFilled = passwordA.length !== 0 && passwordB.length !== 0;

        const strongPassword = (passwordA.length > 7
            && /\d/.test(passwordA) && /[a-zA-Z]/.test(passwordA));

        const passwordsSame = (passwordA === passwordB);

        const emailCorrect = validator.isEmail(email);

        return {
            inputsFilled,
            strongPassword,
            passwordsSame,
            emailCorrect,
        };
    };

    render() {
        const {
            registerSuccessful,
            registerErrored,
            registering,
            errorMessage,
            email,
            passwordA,
            passwordB,
        } = this.state;

        const { strongPassword, passwordsSame, emailCorrect } = this.isDataCorrect();

        return (
            <Popup
                size='form'
                noTitle
                noCloseHandler
                className="signup-modal form"
            >
                <h1><TranslatedText transKey="My collection" /></h1>
                <div>
                    {(!registerErrored && registerSuccessful)
                        ? <div className="popup-content">
                            <div className="email-sent">
                                <i className="icon-icon_ok" />
                                <h1>Success</h1>
                                <p className="text-center">Your account was successfully registered.</p>
                                <p className="muted text-center">Redirecting...</p>
                            </div>
                        </div>
                        : <div className="signup-wrapper">
                            <div className="form-wrapper">
                                <div className="signup-form">
                                    {registering && (
                                        <div className="text-center">
                                            <Loading />
                                        </div>
                                    )}
                                    {!registering && (
                                        <Fragment>
                                            <InputField
                                                disabled
                                                value={email}
                                                autoFocus
                                                hasErrored={registerErrored && !emailCorrect}
                                                errorMessage={email.length
                                                    ? 'Sorry, but that email is invalid'
                                                    : 'Please enter a value'
                                                }
                                                onChange={this.onFieldChange('email')}
                                                label={<TranslatedText transKey="Email" />} />
                                            <InputField
                                                value={passwordA}
                                                type={'password'}
                                                hasErrored={registerErrored && !strongPassword}
                                                errorMessage={this.staticTexts.weakPassword}
                                                onChange={this.onFieldChange('passwordA')}
                                                label={<TranslatedText transKey="Password" />} />
                                            <InputField
                                                value={passwordB}
                                                type={'password'}
                                                hasErrored={registerErrored && !passwordsSame}
                                                errorMessage={this.staticTexts.differentPasswords}
                                                onChange={this.onFieldChange('passwordB')}
                                                handleKeyPress={this.handleKeyPress}
                                                label={<TranslatedText transKey='Confirm Password' />} />

                                            <div className="form-msg">
                                                <span className="error-msg">{registerErrored && errorMessage}</span>
                                            </div>
                                        </Fragment>
                                    )}
                                </div>
                                <SignUpInfo />
                            </div>
                            <SignUpActions
                                registerConfirm={this.registerConfirm}
                                registering={registering}
                            />
                        </div>

                    }
                </div>

            </Popup>
        );
    }
}

SignUp.propTypes = {
    userData: PropTypes.shape({
        email: PropTypes.string,
        uuid: PropTypes.string,
    }).isRequired,
};
SignUp.defaultProps = {};

export default withLanguage(withUserData(SignUp));



// WEBPACK FOOTER //
// ./src/scenes/SignUp/index.js